export const unique = data => {
  return data.filter((elem, pos, arr) => {
    return arr.indexOf(elem) == pos
  })
}

export default {
  unique
}
